import React, { useEffect, useState, useCallback } from 'react';
import { getFavorites } from '../api/userApi';
import { fetchSpaceById } from '../api/spaceApi';
import MainContent from '../componets/MainContent';
import { Helmet } from 'react-helmet-async';

const Favorites: React.FC = () => {
  const [favoriteSpaces, setFavoriteSpaces] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const isLoggedIn = !!localStorage.getItem('user_token');

  const fetchFavoriteSpaces = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getFavorites();
      const favoriteIds = (response.body || response).map((id: number | string) => id.toString());
      if (favoriteIds.length === 0) {
        setFavoriteSpaces([]);
        setLoading(false);
        return;
      }
      const spaceResults = await Promise.all(
        favoriteIds.map((id: string) => fetchSpaceById(id))
      );
      const spaces = spaceResults.filter(Boolean);
      const markedSpaces = spaces.map(space => ({
        ...space,
        isFavorite: true
      }));
      setFavoriteSpaces(markedSpaces);
    } catch {
      setFavoriteSpaces([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFavoriteSpaces();
  }, [fetchFavoriteSpaces]);

  return (
    <div className="min-h-screen p-6 bg-gray-50">
      <Helmet>
        <title>찜한 공간 | BIN-GO</title>
        <meta name="description" content="내가 찜한 공간을 한눈에! 관심공간 리스트를 관리하세요." />
        <meta property="og:title" content="찜한 공간 | BIN-GO" />
        <meta property="og:description" content="내가 찜한 공간 리스트." />
      </Helmet>
      <h1 className="text-2xl font-bold mb-4">찜한 공간</h1>
      <MainContent
        spaces={favoriteSpaces}
        loading={loading}
        onFavoriteChange={fetchFavoriteSpaces}
        isLoggedIn={isLoggedIn}
      />
    </div>
  );
};

export default Favorites;


